import React from 'react';
import { FileText } from 'lucide-react';

const PlaceholderPage = ({ title, subtitle }) => {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-white rounded-2xl shadow-lg p-12 text-center">
          <div className="bg-[#1a4d8f]/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
            <FileText className="w-10 h-10 text-[#1a4d8f]" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">{title}</h1>
          {subtitle && <p className="text-lg text-gray-600 mb-8">{subtitle}</p>}
          <div className="bg-gray-50 rounded-lg p-8 max-w-2xl mx-auto">
            <p className="text-gray-700 leading-relaxed">
              Esta sección está en construcción. El contenido estará disponible próximamente.
            </p>
            <p className="text-gray-600 text-sm mt-4">
              Para más información, contáctenos al +52 33 1061 8187
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaceholderPage;